<template>
  <tx-autocomplete
    :model-value="modelValue" :label="label" :placeholder="placeholder" :errors="errors"
    :fetch-suggestions="searchModelNumber" value-prop="ModelNumber" display-prop="ModelNumber"
    :required="required" :disabled="disabled" :clearable="clearable" @update:model-value="onModelValueUpdated"
  />
</template>

<script setup lang="ts">
import type { ErrorObject } from '@vuelidate/core'
import TxAutocomplete from './TxAutocomplete.vue'
import utils from '@/services/utils'
import { useUserStore } from '@/store/userData'
import type { ArticleFilterModel } from '@/api/t1/model/articleModel'
import { FilterCriteriaMode } from '@/models/filterCriteria'
import { getArticleFilterValues } from '@/api/t1/article'

interface IProps {
  modelValue?: string | number | null
  label?: string
  placeholder?: string
  required?: boolean
  disabled?: boolean
  clearable?: boolean
  errors?: ErrorObject[]
}

withDefaults(defineProps<IProps>(), {
  modelValue: null,
  label: '',
  placeholder: '',
  required: false,
  clearable: false,
  disabled: false,
  errors: () => [] as ErrorObject[],
})

const emit = defineEmits<{
  (e: 'update:modelValue', val: string | number | null): void
}>()

const userStore = useUserStore()

function searchModelNumber(query: string, callback) {
  if (userStore.activeCatalog) {
    const filters: ArticleFilterModel[] = []
    if (utils.isDefined(query)) {
      filters.push({ attribute: 'ModelNumber', mode: FilterCriteriaMode.startWithString, value: query.trim(), exclude: false })
    }

    getArticleFilterValues(userStore.activeCatalog.CatalogCode, { attributes: ['ModelNumber'], filters, sortCriteria: { attribute: 'ModelNumber', isAsc: true } }, 200)
      .then((data) => {
        callback(data)
      })
  }
  else {
    callback([])
  }
}

function onModelValueUpdated(val?: string | number) {
  emit('update:modelValue', val || null)
}
</script>
